/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Fonts, Spacings } from '@styles/index';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import { Container } from '@comp/CMSHTMLContent/CMSHTMLContent';
import setupInitialProps from '@utils/setupInitialProps';

import DangerousWithSanitization from '@base/DangerousWithSanitization';
import { fetchCentresTAndC } from '@api/fetchers/offline-centres';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const StyledContainer = styled(Container)`
  h3 {
    font-size: ${Fonts.H3};
  }

  a > h3 {
    padding-top: 100px;
    margin-top: -100px;
  }
`;

const ContentTableWrapper = styled.div`
  z-index: 1;
`;

const StyledHeading = styled.div`
  margin-bottom: ${Spacings.SPACING_8B};
`;

const UnacademyCentreTerms = ({ response }) => {
  const router = useRouter();
  const { pathname } = router;

  const { tableHeadings, htmlTerms } = response || {};

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <Wrapper>
          <StyledHeading>
            <H2 as="h1">Unacademy Centres Terms and Conditions</H2>
          </StyledHeading>

          {tableHeadings?.tableData ? (
            <ContentTableWrapper>
              <ContentsTable data={tableHeadings?.tableData} />
            </ContentTableWrapper>
          ) : null}
          {htmlTerms ? (
            <DangerousWithSanitization as={StyledContainer} html={htmlTerms} />
          ) : null}
        </Wrapper>
      </RightContainer>
    </>
  );
};

UnacademyCentreTerms.pageInfo = {
  name: 'Unacademy Centre Terms',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

UnacademyCentreTerms.getInitialProps = setupInitialProps(async () => {
  try {
    const response = await fetchCentresTAndC('centres-terms');
    return { response };
  } catch (error) {
    return {};
  }
}, UnacademyCentreTerms.pageInfo);

export default UnacademyCentreTerms;
UnacademyCentreTerms.Layout = Layout;
